"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRemoveBodyScroll = exports.shouldShowBackdrop = exports.onEnterPressHandler = void 0;
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
var _utils = require("../../utils");
var _getSearchUrl = require("../../utils/getSearchUrl");
const onEnterPressHandler = e => {
  if (e.key === 'Enter') {
    const {
      value: searchQuery
    } = e.currentTarget;
    (0, _utils.goToPage)((0, _getSearchUrl.getSearchUrl)(searchQuery));
  }
};
exports.onEnterPressHandler = onEnterPressHandler;
const useRemoveBodyScroll = enabled => {
  (0, _react.useEffect)(() => {
    if (enabled) {
      document.body.classList.add(_presentationUtils.TOP_NAV_NO_SCROLL);
    } else {
      document.body.classList.remove(_presentationUtils.TOP_NAV_NO_SCROLL);
    }
    return () => {
      document.body.classList.remove(_presentationUtils.TOP_NAV_NO_SCROLL);
    };
  }, [enabled]);
};
exports.useRemoveBodyScroll = useRemoveBodyScroll;
const shouldShowBackdrop = ({
  isMobile,
  isFocused,
  isMenuActive
}) => isMobile && isFocused && !isMenuActive || !isMobile && (isFocused || isMenuActive);
exports.shouldShowBackdrop = shouldShowBackdrop;